import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { AppContextStore } from "$stores/app-context";

const SectionRoute = ({ sectionKey }) => {
    const enabled = AppContextStore.useState((s) => s.settings?.sections?.[sectionKey] ?? false);

    if (!enabled) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default SectionRoute;
